import { useQuery } from 'react-query';
import { fetchNormalizedResumeMetadataTerms } from 'react-scale/components/GrowthCenter/OnboardingControlPanel/api';

export const useNormalizedResumeMetadataTerms = (terms: string[]) => {
  return useQuery<string[]>({
    queryKey: ['normalizedResumeMetadataTerms', terms],
    queryFn: async () => {
      return fetchNormalizedResumeMetadataTerms(terms);
    },
    enabled: !!terms,
  });
};
